import { render, staticRenderFns } from "./Livedtail.vue?vue&type=template&id=35e9f9f3&"
import script from "./Livedtail.vue?vue&type=script&lang=js&"
export * from "./Livedtail.vue?vue&type=script&lang=js&"
import style0 from "./Livedtail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports